import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-16 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20dark%20background%20with%20flowing%20warm%20red%20and%20gold%20gradient%20waves%2C%20abstract%20smooth%20curves%2C%20luxurious%20atmosphere%2C%20professional%20data%20visualization%20style%2C%20clean%20minimalist%2C%20no%20text%20or%20letters%2C%20soft%20glowing%20accents&width=1600&height=400&seq=cta-bg-2024&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/75 to-secondary-900/75"></div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-background-50">
          立即注册，体验全新彩客网
        </h2>
        <p className="mt-3 text-sm md:text-base text-background-50/70 max-w-xl mx-auto">
          注册即享专属福利，获取最新开奖推送和智能分析服务
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
          <Link
            to="/about"
            className="px-8 py-3 bg-accent-500 text-background-50 rounded-lg text-sm md:text-base font-medium hover:bg-accent-600 transition-all cursor-pointer whitespace-nowrap"
          >
            免费注册账号
          </Link>
          <Link
            to="/category/shuangseqiu"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 rounded-lg text-sm md:text-base font-medium hover:bg-background-50/25 transition-all cursor-pointer whitespace-nowrap"
          >
            查看开奖数据
          </Link>
        </div>
      </div>
    </section>
  );
}